module.exports = __webpack_public_path__ + "static/media/arsenal_featured_player.88bbd22f.png";